import * as angular from 'angular';
import './staff-members.scss';
import { Component } from 'ng-metadata/core';


/**
 * @ngdoc directive
 * @name mwMediaSourceDocumentStaffMembersComponent
 * @module mw.components.contentDocuments
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 */

@Component({
    selector: 'mw-media-source-document-staff-members',
    template: `
        <ng-transclude></ng-transclude>
    `,
    legacy: {
        transclude: true
    }
})
export class MediaSourceDocumentStaffMembersComponent {

}


// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/staff-members/staff-members.component.ts